import { ReactNode, useContext, useMemo, useState } from 'react';

import { AnimatingCircleContext } from './AnimatingCircleContext';
export { default as AnimatingCircle } from './AnimatingCircle';
export * from './AnimatingCircleContext';

export const useAnimatingCircleContext = () =>
  useContext(AnimatingCircleContext);

export const AnimatingCircleWrapper = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [targetId, setTargetId] = useState('');
  return (
    <AnimatingCircleContext.Provider
      value={useMemo(() => ({ targetId, setTargetId }), [targetId])}
    >
      {children}
    </AnimatingCircleContext.Provider>
  );
};
